import { StockCard } from './IStockCard'

export interface IBarangJadiRequestBatch {
  batchNumber: string
  qty: number | string
}

export interface IBarangJadiRequestItem {
  productId: number
  productName: string
  packagingId?: string
  packagingName?: string
  premixId?: string
  fillingAmount?: number | string | null
  fillingUnit?: string | null
  labelId?: string | null
  weight?: number | string
  halal?: boolean
  box?: boolean
  wrap?: boolean
  seal?: boolean
  batchNumber: string
  qty: number | string
}

export interface IBarangJadiRequest {
  barangJadiRequestId?: string | number
  barangJadiRequestDisplayId?: string
  inOutDirection: string
  sourceOrDestination: string
  notes: string
  items: IBarangJadiRequestItem[]
  stockCard?: StockCard | null
  createdBy?: string
  createdAt?: Date | string | null
}

export class BarangJadiRequest implements IBarangJadiRequest {
  barangJadiRequestId?: string | number
  barangJadiRequestDisplayId?: string
  inOutDirection: string
  sourceOrDestination: string
  notes: string
  items: IBarangJadiRequestItem[]
  stockCard: StockCard | null
  createdBy?: string
  createdAt?: Date | string | null

  constructor({
    barangJadiRequestId,
    barangJadiRequestDisplayId,
    inOutDirection,
    sourceOrDestination,
    notes,
    items,
    stockCard,
    createdBy,
    createdAt,
  }: Partial<IBarangJadiRequest> = {}) {
    this.barangJadiRequestId = barangJadiRequestId ?? ''
    this.barangJadiRequestDisplayId = barangJadiRequestDisplayId ?? ''
    this.inOutDirection = inOutDirection ?? ''
    this.sourceOrDestination = sourceOrDestination ?? ''
    this.notes = notes ?? ''
    this.items = items ?? []
    this.stockCard = stockCard ?? null
    this.createdBy = createdBy ?? ''
    this.createdAt = createdAt ?? null
  }
}

export const BARANG_JADI_IN_OPTIONS = [
  { key: 'Adjustment', label: 'Adjustment' },
  { key: 'Kembalian sisa pameran', label: 'Kembalian sisa pameran' },
  { key: 'Marketing salah input', label: 'Marketing salah input' },
  { key: 'Perlu tindakan', label: 'Perlu tindakan:' },
] as const

export const PERLU_TINDAKAN_OPTIONS = [
  'Bets ulang',
  'Ganti Kemasan',
  'Ganti Segel',
  'Ganti Label',
  'Ganti Isi',
  'Ganti Dus',
]

export const BARANG_JADI_OUT_OPTIONS = [
  { key: 'Adjustment', label: 'Adjustment' },
  {
    key: 'Stok keluar Gudang Jadi Masuk Gudang STJ',
    label: 'Stok keluar Gudang Jadi Masuk Gudang STJ',
  },
  { key: 'Kebutuhan Pameran', label: 'Kebutuhan Pameran' },
  {
    key: 'Sample Free Cust / Penelitian Pak Wong',
    label: 'Sample Free Cust / Penelitian Pak Wong',
  },
  { key: 'Sample Pertinggal', label: 'Sample Pertinggal' },
  {
    key: 'Selesai tindakan, return ke customer',
    label: 'Selesai tindakan, return ke customer:',
  },
] as const
